import { createContext, useContext } from "react";
import type { PageContextValue } from "./page-provider";

export const PageContext = createContext<PageContextValue | null>(null);

export const usePage = () => {
  const context = useContext(PageContext);

  if (!context) {
    throw new Error("usePage must be used within a PageProvider");
  }

  return context;
};
